/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import { FC, ReactElement, useCallback, useState } from 'react'

import { ASSETS, defaultCardImage, EXTENDED_ACCESS_GUARANTEE_PRODUCT_TYPE } from '../../../constants'
import { CartItem, ProductMediaUrl } from '../../../types'
import { random } from '../../../utils'

import './index.css'

type CartItemImageProps = {
  cartItem: CartItem
}
const CartItemImage: FC<CartItemImageProps> = ({ cartItem }): ReactElement => {
  const [product] = useState(cartItem.product)
  const getProductImage = useCallback((): ProductMediaUrl => {
    const cardImage = product?.mediaUrls?.find(
      (img) => img.displayIntent && ['card_image', 'card-image', 'CardImage'].includes(img.displayIntent)
    )

    return cardImage || defaultCardImage
  }, [product?.mediaUrls])

  const productImageAttrs = useCallback((): { src: string; alt?: string; height: string; width: string; className?: string } => {
    const image = getProductImage()
    const isAccessGuarantee = cartItem.cartItemApiInfo.productVariantType === EXTENDED_ACCESS_GUARANTEE_PRODUCT_TYPE
    return {
      src: isAccessGuarantee
        ? `${ASSETS}/default/cart/accessGuarantee.png`
        : image.url || `${ASSETS}/default/products/Mobile_${random(4, 1)}.jpg`,
      alt: isAccessGuarantee ? 'Extended Access Guarantee' : image.alt || 'On The Hub Logo',
      height: 'auto',
      width: 'auto',
      className: `cart-item-img ${isAccessGuarantee ? 'cart-item__accessGuarantee-image' : ''}`,
    }
  }, [cartItem, getProductImage])

  return (
    <>
      <img
        alt="On The Hub Logo"
        {...productImageAttrs()}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null
          currentTarget.src = `${ASSETS}/default/products/Mobile_${random(4, 1)}.jpg`
        }}
      />
    </>
  )
}

export default CartItemImage
